import React, { useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import styles from "./CancelOrderConfirmationPopup.module.scss";
import congratsImg from "../../../assets/images/congratsPopGot.png";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../../hooks/useLanguage";
import styled from "styled-components";
import current from "../../../assets/images/current.png";
import diamond from "../../../assets/images/diamond.png";
import loader from "../../../assets/images/loading.gif";

const CancelOrderConfirmationPopup = ({
  showCancelOrderConfirmation,
  setShowCancelOrderConfirmation,
  onFinish,
  cancelOrderLoading,
}) => {
  // const { t } = useTranslation();
  const t = useLanguage();

  const handledHide = () => {
    setShowCancelOrderConfirmation(false);
  };

  return (
    <Modal
      show={showCancelOrderConfirmation}
      backdrop="true"
      className={`${styles.buyPop} bottomPopd`}
      centered
      keyboard={false}
    >
      <div className="modalWrpper">
        <Modal.Body className=" position-relative">
          {cancelOrderLoading && (
            <div
              className="h-100 w-100 position-absolute d-flex align-items-center justify-content-center"
              style={{
                borderRadius: 20,
                background: "#00000080",
                zIndex: 999,
              }}
            >
              <img
                src={loader}
                alt=""
                className="img-fluid"
                style={{ height: 50 }}
              />
            </div>
          )}
          {/* <Button
            onClick={handledHide}
            variant="transparent"
            className="border-0 p-0 position-absolute"
            style={{ top: 15, right: 15, zIndex: 999 }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.0024 26.0048C20.1834 26.0048 26.0048 20.1834 26.0048 13.0024C26.0048 5.82137 20.1834 0 13.0024 0C5.82137 0 0 5.82137 0 13.0024C0 20.1834 5.82137 26.0048 13.0024 26.0048ZM13.0062 14.1485L18.1747 19.3251L19.3205 18.1711L14.152 13.0026L19.3205 7.83412L18.1747 6.68827L13.0062 11.8568L7.83767 6.68015L6.6837 7.83412L11.8603 13.0026L6.6837 18.1711L7.83767 19.3251L13.0062 14.1485Z"
                fill="#506380"
              />
            </svg>
          </Button> */}
          <div className="text-center mt-4">
            <div className="py-2">
              <div
                className="d-flex justify-content-center align-items-center mx-auto rounded-pill mb-3"
                style={{ height: 60, width: 60, background: "#ff000040" }}
              >
                {warningIcn}
              </div>
              <h6 className="m-0 fw-bold text-white">
                Closing this window now may result in loss of funds if the
                payment is already in progress. Please wait for completion or
                contact support
              </h6>
            </div>
            <div className="mt-3 text-center pb-2 d-flex align-items-center justify-center w-100 gap-10">
              <Button
                onClick={handledHide}
                className="d-inline-flex  align-items-center justify-content-center fw-bold commonBtn border-0 w-100"
              >
                Wait
              </Button>
              <Button
                onClick={() => {
                  onFinish();
                  setShowCancelOrderConfirmation(false);
                }}
                style={{ maxWidth: 171 }}
                className="d-inline-flex  align-items-center justify-content-center fw-bold commonBtn border-0 w-100"
              >
                Exit Anyway
              </Button>
            </div>
          </div>
        </Modal.Body>
      </div>
    </Modal>
  );
};

const CardList = styled.div`
  .cardWrp {
    background: rgb(21, 21, 22);
    border-radius: 10px;
    min-height: 60px;
    font-size: 14px;
    font-family: "Space Grotesk", sans-serif;
    font-weight: 300;
    border: 1px solid transparent;
    .icn {
      height: 43px;
      width: 46px;
      background: rgb(45, 45, 45);
      border-radius: 10px;
    }
  }
`;

export default CancelOrderConfirmationPopup;

const warningIcn = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.7252 21C2.54187 21 2.3752 20.9543 2.2252 20.863C2.0752 20.7717 1.95853 20.6507 1.8752 20.5C1.79187 20.3493 1.7462 20.1867 1.7382 20.012C1.7302 19.8373 1.77587 19.6667 1.8752 19.5L11.1252 3.5C11.2252 3.33333 11.3545 3.20833 11.5132 3.125C11.6719 3.04167 11.8342 3 12.0002 3C12.1662 3 12.3289 3.04167 12.4882 3.125C12.6475 3.20833 12.7765 3.33333 12.8752 3.5L22.1252 19.5C22.2252 19.6667 22.2712 19.8377 22.2632 20.013C22.2552 20.1883 22.2092 20.3507 22.1252 20.5C22.0412 20.6493 21.9245 20.7703 21.7752 20.863C21.6259 20.9557 21.4592 21.0013 21.2752 21H2.7252ZM4.4502 19H19.5502L12.0002 6L4.4502 19ZM12.7132 17.713C12.9045 17.521 13.0002 17.2833 13.0002 17C13.0002 16.7167 12.9042 16.4793 12.7122 16.288C12.5202 16.0967 12.2829 16.0007 12.0002 16C11.7175 15.9993 11.4802 16.0953 11.2882 16.288C11.0962 16.4807 11.0002 16.718 11.0002 17C11.0002 17.282 11.0962 17.5197 11.2882 17.713C11.4802 17.9063 11.7175 18.002 12.0002 18C12.2829 17.998 12.5205 17.903 12.7132 17.713ZM12.7132 14.712C12.9045 14.5207 13.0002 14.2833 13.0002 14V11C13.0002 10.7167 12.9042 10.4793 12.7122 10.288C12.5202 10.0967 12.2829 10.0007 12.0002 10C11.7175 9.99933 11.4802 10.0953 11.2882 10.288C11.0962 10.4807 11.0002 10.718 11.0002 11V14C11.0002 14.2833 11.0962 14.521 11.2882 14.713C11.4802 14.905 11.7175 15.0007 12.0002 15C12.2829 14.9993 12.5205 14.9033 12.7132 14.712Z"
      fill="#ff0000"
    />
  </svg>
);
